import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import { ApolloProvider } from "@apollo/client";
import LandingPage from "./pages/LandingPage/LandingPage";
import Login from "./pages/Login/Login";
import Logout from "./pages/Login/Logout";
import ExampleMode from "./pages/Home/ExampleMode";
import FreshMode from "./pages/Home/FreshMode";

import Home from "./pages/Home/Home";
import Account from "./pages/Home/Account/Account";
import AuthProvider from "./auth/AuthProvider";
import client from "./api/ApiClient";
import Dashboard from "./pages/Home/Dashboard/Dashboard";
import { ErrorPage } from "./ErrorPage";
import Settings from "./pages/Home/Settings/Settings";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import WebpageDataView from "./pages/Home/Webpage/WebpageDataView";
import Plans from "./pages/Home/Checkout/Plans";
import Return from "./pages/Home/Checkout/Return";
import PrivacyPolicy from "./pages/LandingPage/PrivacyPolicy";
import Terms from "./pages/LandingPage/Terms";

// TODO: Add lazy loading to stop loading of any non-protected route
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "account",
        element: <Account />,
      },
      {
        path: "info",
        element: <WebpageDataView />,
      },
      {
        path: "webpage",
        element: <FreshMode />,
      },
      {
        path: "example",
        element: <ExampleMode />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "plans",
        element: <Plans />,
      },
      {
        path: "checkout/return",
        element: <Return />,
      },
    ],
  },
  { path: "landing", element: <LandingPage /> },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "privacypolicy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms",
    element: <Terms />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <AuthProvider>
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </AuthProvider>,
);
